import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { LANGUAGE, STUDENT, NA } from '../../../constants/shared/CommonConstants';
import SkillsTable from '../skillsTable/SkillsTable';
import SupportBlockGroups from '../supportBlockGroups/SupportBlockGroups';
import './StudentProfile.scss';
import { getDefaultDescriptionBlock } from '../../../utils/shared/dualLanguageUtils';

const { ENGLISH, SPANISH } = LANGUAGE;

const StudentProfile = ({ studentData, licensingInfo, onActivityClickHandler }) => {
    const { overallDescription } = studentData;
    const firstName = get(studentData, STUDENT.FIRST_NAME);
    const lastName = get(studentData, STUDENT.LAST_NAME);
    const overallStatusesData = get(studentData, 'overallStatuses', []);
    const overallStatuses = {
        [ENGLISH]: get(
            overallStatusesData.find(status => status.language === ENGLISH),
            'level',
            NA,
        ),
        [SPANISH]: get(
            overallStatusesData.find(status => status.language === SPANISH),
            'level',
            NA,
        ),
    };
    const skills = get(studentData, 'skills', []);
    const measureResults = get(studentData, 'measureResults', {});
    const groups = get(studentData, 'groups', []);

    return (
        <div className="student-profile">
            <div className="d-flex justify-content-between">
                <section className="col-md-8 row">
                    <h2 className="student-name">
                        {firstName} {lastName}
                    </h2>
                    <p className="font-medium text-justify">
                        {overallDescription || getDefaultDescriptionBlock(licensingInfo)}
                    </p>
                </section>
                <section className="d-flex flex-column">
                    <h3 className="overall-skills-title">Overall Literacy Skill</h3>
                    <table className="overall-skills-table">
                        <tbody>
                            <tr>
                                <td className="overall-skills-cell">{ENGLISH}</td>
                                <td className="overall-skills-cell">{SPANISH}</td>
                            </tr>
                            <tr className="data-row">
                                <td className="overall-skills-cell">{overallStatuses[ENGLISH]}</td>
                                <td className="overall-skills-cell">{overallStatuses[SPANISH]}</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
            <SkillsTable skills={skills} results={measureResults} />
            <section>
                <h3 className="support-block-title">
                    Supporting {firstName}’s Biliteracy Development
                </h3>
                {isEmpty(groups) ? (
                    getDefaultDescriptionBlock(licensingInfo)
                ) : (
                    <SupportBlockGroups
                        groups={groups}
                        onActivityClickHandler={onActivityClickHandler}
                    />
                )}
            </section>
        </div>
    );
};

StudentProfile.defaultProps = {
    onActivityClickHandler: () => {},
    studentData: {},
    licensingInfo: [],
};

StudentProfile.propTypes = {
    onActivityClickHandler: PropTypes.func,
    studentData: PropTypes.object,
    licensingInfo: PropTypes.arrayOf(PropTypes.string),
};

export default StudentProfile;
